import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

const tuyaService = {
  /**
   * Get device list from backend (with server-side caching)
   */
  async getDevices() {
    const response = await axios.get(`${API_URL}/tuya/devices`, {
      withCredentials: true
    })
    return response.data
  },

  /**
   * Control a device
   */
  async controlDevice(deviceId, action, fieldValue, fieldName = 'value') {
    const response = await axios.post(`${API_URL}/tuya/control`, {
      deviceId,
      action,
      fieldValue,
      fieldName
    }, {
      withCredentials: true
    })
    return response.data
  },

  /**
   * Clear device cache (force refresh)
   */
  async clearCache() {
    const response = await axios.post(`${API_URL}/tuya/cache/clear`, {}, {
      withCredentials: true
    })
    return response.data
  }
}

export default tuyaService
